// Les quêtes du jour avancent côté back au moment où une action est enregistrée
// (temps passé envoyé au changement de session, session cochée). La liste des
// quêtes, elle, ne relisait qu'au montage ou toutes les 30 s : on la prévient
// donc dès que l'enregistrement a réussi, et elle se relit aussitôt.
export const QUESTS_REFRESH_EVENT = "believemy:quests-refresh";

// Pendant une vidéo, chaque minute regardée fait avancer la quête de temps à
// l'écran, sans appel au serveur : le temps ne part au back qu'au changement de
// session. Le vrai chiffre corrige ensuite l'affichage.
export const QUESTS_MINUTE_EVENT = "believemy:quests-minute";

// Quand la minute affichée termine la quête, la liste demande à la page
// d'envoyer tout de suite le temps regardé : le coffre devient réclamable sans
// attendre la session suivante.
export const QUESTS_FLUSH_EVENT = "believemy:quests-flush";

const emit = (name) => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new Event(name));
};

export const refreshQuests = () => emit(QUESTS_REFRESH_EVENT);
export const announceLearningMinute = () => emit(QUESTS_MINUTE_EVENT);
export const flushLearningTime = () => emit(QUESTS_FLUSH_EVENT);

// À appeler à chaque relevé du lecteur : prévient la liste des quêtes quand une
// minute pleine vient d'être franchie. `watchedRef` cumule les secondes de la page
// (il n'est jamais remis à zéro par les envois au serveur).
export function countWatchedTime(watchedRef, seconds) {
    const before = watchedRef.current || 0;
    watchedRef.current = before + seconds;
    if (Math.floor(watchedRef.current / 60) > Math.floor(before / 60)) {
        announceLearningMinute();
    }
}
